import { graphql } from "../../generated";

export const updateClientSettingsMutation = graphql(/* GraphQL */ `
    mutation UpdateClientSettings($clientId: String!, $settings: ClientSettingsInput!) {
        updateClientSettings(clientId: $clientId, settings: $settings) {
            id
        }
    }
`);

export const updateClientBillingMutation = graphql(/* GraphQL */ `
    mutation UpdateClientBilling($clientId: String!, $billing: ClientBillingInput!) {
        updateClientBilling(clientId: $clientId, billing: $billing) {
            id
        }
    }
`);

export const inviteClientUserMutation = graphql(/* GraphQL */ `
    mutation InviteClientUser(
        $clientId: String!
        $clientUser: ClientUserInput!
        $clientUserRole: ClientUserRole!
        $clientUserLocale: String
    ) {
        inviteClientUser(
            clientId: $clientId
            clientUser: $clientUser
            clientUserRole: $clientUserRole
            clientUserLocale: $clientUserLocale
        ) {
            id
        }
    }
`);

export const deactivateClientUserMutation = graphql(/* GraphQL */ `
    mutation DeactivateClientUser($clientId: String!, $clientUserId: String!) {
        deactivateClientUser(clientId: $clientId, clientUserId: $clientUserId) {
            id
            role
            status
        }
    }
`);

export const requestTenantCreationMutation = graphql(/* GraphQL */ `
    mutation RequestTenantCreation($clientId: String!, $message: String) {
        requestTenantCreation(clientId: $clientId, message: $message)
    }
`);

export const issueChargeCreditsInvoiceMutation = graphql(/* GraphQL */ `
    mutation IssueChargeCreditsInvoice($clientId: String!, $currency: String!, $amountCredits: Int!) {
        issueChargeCreditsInvoice(clientId: $clientId, currency: $currency, amountCredits: $amountCredits) {
            ...invoiceFields
        }
    }
`);

export const chargeCreditsMutation = graphql(/* GraphQL */ `
    mutation chargeCredits($clientId: String!, $currency: String!, $amountCredits: Int!) {
        chargeCredits(clientId: $clientId, currency: $currency, amountCredits: $amountCredits)
    }
`);
